import React from "react";
import { Tag } from "antd";
import { $t } from "~/i18n.js";

export const AlertTag = ({ color = "red", style = {}, ...props }) => {
  return (
    <Tag color={color} style={style} {...props}>
      {$t("Let op")}!
    </Tag>
  );
};
